module.exports = {"id":"176636","name":"Kamil Vacek","rating":"73","photo":"./data/images/photos/4/176636.png","club":{"name":"Śląsk Wrocław","logo":"./data/images/clubs/SlaskWrocław.png"},"positions":["MC","MDC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KamilVacek0.json
// module id = 2284
// module chunks = 0